var map = {
	"./aboutme.png": "a56a",
	"./blogging.png": "c1b1",
	"./bubbles1.png": "94e0",
	"./bubbles2.png": "9af2",
	"./contact.png": "9fa8",
	"./kitkat.png": "cc86",
	"./recentprojects.png": "1b19",
	"./services.png": "67e9",
	"./todo.png": "37cd",
	"./trelos.png": "4e1a",
	"./trelos1.png": "b25d",
	"./weather.png": "b18e",
	"./welcome.png": "5d18"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";